require('./_set-species')('Array');


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/socialtravel/shared/~/core-js/modules/es6.array.species.js
// module id = 742
// module chunks = 0